import React, { useEffect, useState } from 'react';
import AppLoader from './AppLoader';

const EXIT_MS = 680;
const MIN_SHOW_MS = 900;

const AppBoot = ({ children }) => {
  const [phase, setPhase] = useState('loading');

  useEffect(() => {
    let exitTimer;

    const started = performance.now();

    const beginExit = () => {
      const elapsed = performance.now() - started;
      const wait = Math.max(0, MIN_SHOW_MS - elapsed);

      window.setTimeout(() => {
        setPhase('exiting');
        exitTimer = window.setTimeout(() => setPhase('done'), EXIT_MS);
      }, wait);
    };

    if (document.readyState === 'complete') {
      beginExit();
    } else {
      window.addEventListener('load', beginExit, { once: true });
    }

    return () => {
      window.clearTimeout(exitTimer);
    };
  }, []);

  const booting = phase !== 'done';

  return (
    <>
      {booting && <AppLoader exiting={phase === 'exiting'} />}
      <div className={`app-shell${booting ? ' app-shell--booting' : ' app-shell--ready'}`}>
        {children}
      </div>
    </>
  );
};

export default AppBoot;
